/**
 * Kuota tombol "Generate New Pin".
 *
 * Angkanya WAJIB dibaca dari `PinRooms[].RegenerateCount` yang dikirim backend — jangan pernah
 * dihitung ulang dari jumlah baris PinRoom. Regenerate meng-UPDATE baris yang sama (bukan
 * menyisipkan baris baru), jadi jumlah baris tak pernah bertambah walau tombolnya ditekan
 * berkali-kali. Versi lama juga menyaring `IsFromUser === true`, padahal tak ada satu pun jalur
 * di backend yang menulis `true` — hasilnya hitungan selalu 0, tampilan selalu "0 / 3", dan
 * kuotanya tidak pernah berlaku di sisi mana pun.
 *
 * Logika ini dulu disalin di beberapa halaman dan menyimpang sendiri-sendiri; itu sebabnya ia
 * sekarang tinggal di satu tempat. Backend tetap penentu akhirnya — ini hanya untuk mematikan
 * tombol lebih awal supaya tamu tak menekan sesuatu yang pasti ditolak.
 */

const DEFAULT_MAX_GENERATE_PIN = 3;

export function userGeneratedPinCount(detail) {
    const pins = detail?.PinRooms;
    if (!Array.isArray(pins) || pins.length === 0) return 0;
    // Multi-doorlock menulis angka yang sama ke tiap baris; ambil tertinggi supaya baris yang
    // tertinggal (mis. lock yang baru dipasang) tidak mereset hitungan.
    return pins.reduce((max, pin) => Math.max(max, Number(pin?.RegenerateCount ?? 0) || 0), 0);
}

export function maxGeneratePin(detail) {
    const max = Number(detail?.MaxGeneratePin);
    // `|| 3` yang lama mengubah nilai 0 jadi 3 — padahal 0 justru cara property mematikan fitur ini.
    return Number.isFinite(max) && max >= 0 ? max : DEFAULT_MAX_GENERATE_PIN;
}

export function remainingGeneratePin(detail) {
    return Math.max(0, maxGeneratePin(detail) - userGeneratedPinCount(detail));
}

export function canGeneratePin(detail) {
    return remainingGeneratePin(detail) > 0;
}
